import {
  Box,
  Flex,
  Heading,
  Image,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  UnorderedList,
  ListItem,
} from "@chakra-ui/react";

import Banner from "../../assets/homeImage/banner.png";

import GradientTextWithStroke from "./index";
import React from "react";

const Privacy = () => {
  const tableData = [
    {
      level: "Level 1",
      channel: "In-Platform Automated Support",
      description:
        "User-friendly automated system for immediate transaction-related queries. We aim to resolve within 24-48 hours.",
    },
    {
      level: "Level 2",
      channel: "Customer Support Team",
      description:
        "Option to speak with a dedicated Customer Support Team via the Digital Venue if Level 1 is unsatisfactory. Resolution attempt within 24-48 hours.",
    },
    {
      level: "Level 3",
      channel: "Grievance Redressal Officer",
      description:
        "For unresolved complaints or grievances pertaining to Terms violations, objectionable content, or access issues.",
    },
  ];

  const tableData1 = [
    {
      category: "Financial Management",
      practice:
        "Only commit funds to your Winnsta Wallet that are within your disposable income. Never use money required for essential expenses such as housing, food, education, or bills. Do not borrow funds to support your activities on the Digital Venue. Avoid deploying all available funds in a single game or session.",
    },
    {
      category: "Time Management",
      practice:
        "Pre-determine your play sessions and the amount of time you spend on the Digital Venue, and stick to this plan. Take regular breaks and time-outs. Ensure your gameplay duration is balanced with other life activities, work, and social engagements.",
    },
    {
      category: "Emotional State",
      practice:
        "Refrain from engaging with the games when you are feeling stressed, depressed, angry, or overly tired. A clear mind is essential for making sound decisions.",
    },
    {
      category: "Priorities",
      practice:
        "Always complete your personal and professional obligations before starting a game session. Gameplay should never take precedence over important tasks.",
    },
    {
      category: "Competency",
      practice:
        "Participate in games that align with your skill level and financial capacity. Resist the urge to enter high-stakes environments, even after a consistent run of successful outcomes.",
    },
  ];

  return (
    <Box backgroundColor={"#3A005E"}>
      <Box
        bgImage={`url(${Banner})`}
        bgSize="cover"
        bgPosition="center"
        w="100%"
        h={{ base: "300px", md: "469px" }}
        px={{ base: 4, md: 20 }}
        py={{ base: 8, md: 12 }}
        color="white"
      >
        <Flex direction="column" justify="center" align="center" h="100%">
          <Box
            textAlign={{ base: "center", md: "right" }}
            ml={{ base: 0, md: "50%" }} // <- sets content to start at 50% width on md screens
          >
            <GradientTextWithStroke
              text=" Community Standards"
              desktopFontSize={70}
              mobileFontSize={60}
              strokeColor="#5c2d06"
              strokeWidth={5}
              gradientStops={[
                { offset: "25%", color: "#FAECA4" },
                { offset: "100%", color: "#B5763A" },
              ]}
            />
            <Text
              fontSize={{ base: "16px", md: "25px" }}
              fontStyle="italic"
              fontWeight="500"
              letterSpacing="0.2em"
              mr="280px"
            >
              {/* Winnsta - GAMES */}
            </Text>
          </Box>
        </Flex>
      </Box>

      {/* Section 3: Text */}
      <Box maxW="100%" py={6} px={4}>
        <Text textAlign="center" fontSize="35px" color="white" mb={6}>
          Winnsta Gaming - Community Standards for Interaction
        </Text>

        <Flex
          width="100%"
          justifyContent="center"
          alignItems="center"
          color="#A1A1A1"
        >
          <Flex
            width={{ base: "90%", md: "80%" }}
            justifyContent="start"
            alignItems="start"
            flexDir={"column"}
          >
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Introduction
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              <b>Winnsta Gaming ("Winnsta," "our," "we," "us")</b> offers an online
              environment, the "<b>Digital Venue</b>," which hosts skill-based games
              playable casually or for real money, along with various content
              and related solutions (<b>"Offerings"</b>). Our Offerings enable <b>Users
              ("you," "your")</b> to engage in interactive activities, including
              communication, chat, or discussions with other Users and Winnsta
              representatives.
            </Text>
            <br></br><br></br>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              These <b>Community Standards ("Guidelines")</b> provide essential
              criteria for behavior that Users must uphold in all interactions
              on or facilitated by the Digital Venue or Offerings.
            </Text>
            <br></br><br></br>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              You must review and strictly adhere to these Guidelines, which are
              to be read in conjunction with our <b>Terms and Conditions, Privacy
              Policy, Responsible Gaming Policy, and Fairplay Policy.</b> Winnsta
              reserves the right to assess and address behaviors not explicitly
              covered herein on a case-by-case basis.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Data Confidentiality
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta values your privacy and employs measures to protect your
              personal data as detailed in our<b> Privacy Policy</b>. However, we
              cannot control the content you share during interactions, which
              may be visible to others. Users are strongly advised <b>never to
              disclose personal identifying information</b> (PII) to other users
              during these interactions.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              User Profile Requirements
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              When selecting your profile identification on the Digital Venue,
              you must adhere to the following baseline rules:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Your profile name must be free of <b>derogatory, offensive,
                  profane language, or slurs</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Your profile name should <b>not contain names or identifiers of
                  other commercial brands</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  You must provide <b>accurate and current documentation</b> if
                  requested to complete your user profile verification.{" "}
                </Text>
              </ListItem>
            </UnorderedList>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Prohibited Interactions and Content
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta maintains a strict prohibition against the dissemination
              of inappropriate content in any form of interaction enabled by the
              Digital Venue. Users are required to use due caution and judgment
              to prevent the publishing, sharing, or transmission of, without
              limitation, the following:
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Profanity and Abuse
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Users must never transmit language or symbols that constitute:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Profanities, abuses, or symbols thereof.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Indecent, vulgar, lewd, or abusive commentary.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Obscene, racial, communal, anti-national, defamatory, or
                  otherwise objectionable content.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Spam and Unsolicited Communication
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Spam is defined as any irrelevant or unwanted messages. Users must
              not:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Send unsolicited messages to others for <b>commercial purposes</b>,
                  including self-promotion.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Send messages that attempt to <b>redirect Users to an external
                  website, application, or platform.</b>{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Repeat the same message to a large number of Users.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Transmit promotional messages, advertisements, or promotional
                  codes for the sale of any products or services.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Ask Users to follow, subscribe to, or join any external
                  channels or profiles.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Harassment and Bullying
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta enforces a <b>zero-tolerance</b> policy against all forms of
              bullying or harassment. Users must not transmit content that:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Targets any individual based on their <b>race, religion,
                  ethnicity, gender, sexual orientation, caste, nationality,
                  age, disability, or political views</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Defames, slanders, or issues derogatory remarks against any
                  individual or group.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Is <b>aggressive, threatening, rude, repetitive, or sexually
                  harassing</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Shames or targets a survivor of violence or abuse.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Releases or threatens to release a person's <b>personal
                  information</b> (e.g., name, phone number, address) or invades
                  their bodily privacy.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Dehumanizes or negatively compares an individual to an animal
                  or inanimate object.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Draws negative attention to a person's physical
                  characteristics, disability, or infirmity.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Encourages or justifies</b> violence, discrimination, or improper
                  behavior against any person.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Discusses a person’s sexual history or attempts to portray
                  them negatively based on alleged sexual behavior.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Calls for or encourages others to engage in harassment or
                  bullying.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Illegal Behavior and Incitement to Violence
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              We have <b>zero tolerance</b> for any content that advocates, calls for,
              or incites violence or illegal activity. Users must not transmit
              material that:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Incites, advocates, or calls for physical harm against any
                  individual or group, or justifies past violence.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Provides instruction or guidance on carrying out violence or
                  illegal acts.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Includes inflammatory or motivated statements that could
                  <b> disturb public peace or harmony</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Depicts violent, gory, or graphic content.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Promotes hatred, advocates terrorism, funding of terrorism, or
                  promotes enmity among groups.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Promotes or justifies illegal financial activities like
                 <b> money-laundering, bribery, or embezzlement</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Threatens the <b>unity, integrity, security, or sovereignty of
                  India</b> or friendly relations with other nations.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Encourages, justifies, or provides instructions for <b>suicide or
                  self-harm</b>.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Impersonation and Fraudulent Activity
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Users must not post any content intended to deceive, misrepresent,
              defraud, or otherwise harm any person. This includes:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Impersonating</b> any person, entity, or Winnsta representative,
                  or falsely claiming affiliation with them.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Manipulating identifiers or data to <b>disguise the origin</b> of
                  content.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Attempting to deceive others for unjust gain, such as
                  promoting <b>ponzi schemes or cash flips</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Falsifying or deleting author attributions or other
                  proprietary notices.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Hate Speech
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              The promotion or use of hate speech in any degree is strictly
              prohibited. Hate speech is any expression that incites, promotes,
              justifies, or glorifies hatred, discrimination, or violence
              against an individual or group based on characteristics such as
             <b> race, religion, gender, sexual orientation, caste, or nationality</b>.
              Users must not transmit content that:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Dehumanizes, denigrates, or stereotypes any individual or
                  group.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Denies or glorifies past or current violence against any
                  group.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Calls for the ostracization, alienation, or segregation of
                  individuals or communities.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Claims an individual or group is inferior and advocates for
                  differential treatment based on that claim.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Intellectual Property Rights Infringement
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Users must not copy, distribute, or create derivative works from
              any content made available on the Digital Venue or shared by other
              Users. Users must not share any content they have not created or
              for which they lack the necessary permission. Winnsta strictly
              prohibits intellectual property rights violations as per its
              Terms.
            </Text>
            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Sexual Content and Nudity
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta strictly prohibits the exchange of sexually charged or
              provocative content. Users must never transmit material that:
            </Text>
            <UnorderedList>
              <ListItem><Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Depicts, encourages, or promotes sexual violence,
                  exploitation, or rape.{" "}
                </Text></ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Describes or depicts <b>nudity, pornography, sexual activities,
                  or intimate images</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Constitutes <b>sexual advances or sexual harassment</b>.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  Encourages or depicts <b>child sexual exploitation, child
                  pornography, or child sexual abuse</b>.{" "}
                </Text>
              </ListItem>
            </UnorderedList>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Consequences of Violations
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Any breach of these Community Standards may lead to severe
              consequences, including legal action. If Winnsta is made aware of
              any User action that violates these Guidelines or harms others, we
              may take appropriate corrective action. This may include, but is
              not limited to:
            </Text>
            <UnorderedList>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Restricting or terminating</b> the offender's access to the
                  Offerings.{" "}
                </Text>
              </ListItem>
              <ListItem>
                <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
                  {" "}
                  <b>Blocking, restricting, or forfeiting</b> any accrued funds,
                  prizes, or privileges.{" "}
                </Text>
              </ListItem>
            </UnorderedList>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              Winnsta may also <b>share details of violative content with law
              enforcement agencies</b> to report or prevent the commission of
              crimes.
            </Text>

            <Text fontSize={"24px"} fontWeight={"bold"} pt="30px">
              Reporting Complaints
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify">
              If you believe these Guidelines have been violated, you have full
              recourse to our <b>3-tiered grievance redressal mechanism</b>, which is
              designed to acknowledge and resolve your concerns promptly.
            </Text>
            <Text fontSize="20px" color="#A1A1A1" textAlign="justify" pb="30px">
              To report any Guidelines violations, please follow the process
              detailed in our <b>Terms and Conditions</b> documentation.
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Privacy;
